import { render, staticRenderFns } from "./WithSubCategory.vue?vue&type=template&id=e6027e1c&scoped=true&"
import script from "./WithSubCategory.vue?vue&type=script&lang=ts&"
export * from "./WithSubCategory.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=e6027e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6027e1c",
  null
  
)

export default component.exports